// extracted by mini-css-extract-plugin
module.exports = {"Surfing":"TextGroupSectionB_Surfing__3xr8P","TextContainer":"TextGroupSectionB_TextContainer__3LKzo"};